import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Payable } from '@models/api.model';
import { FormatData } from '@classes/format-data';

@Component({
  selector: 'app-payables-list-menu',
  template: `<ng-container *ngIf="payable && type === 'options'">
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        [attr.aria-label]="'Order ' + payable._id + ' options'"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu" class="open-sans">
        <button mat-menu-item (click)="onView.emit(payable._id)">
          <img class="ao-row-icon" src="assets/images/ao-icon-view.svg" alt="">
          <span>View invoice</span>
        </button>
        <button
          *ngIf="payable.awaitingCredit"
          [disabled]="!payable.invoiceNumber"
          mat-menu-item
          (click)="onMarkForCredit.emit(payable._id)"
        >
          <mat-icon>payments</mat-icon>
          <span>Mark as credited</span>
        </button>
        <button mat-menu-item (click)="onPrint.emit(payable._id)">
          <mat-icon>print</mat-icon>
          <span>Print</span>
        </button>
        <button mat-menu-item (click)="onDelete.emit(payable._id)">
          <mat-icon>delete</mat-icon>
          <span>Delete</span>
        </button>
      </mat-menu>
    </ng-container>
    <ng-container *ngIf="payable && type === 'log'">
      <button
        *ngIf="payable.log.length || payable.notes?.length"
        [matMenuTriggerFor]="menu"
        class="flex"
        [class.indicator]="payable?.notes?.length"
      >
        <mat-icon>notes</mat-icon>
        <span *ngIf="payable?.notes?.length" class="indicator"></span>
      </button>
      <mat-menu #menu="matMenu" class="payables-log">
        <ng-container *ngIf="payable?.notes?.length">
          <h3 class="order-log-title">Notes</h3>
          <div class="order-log-row" *ngFor="let log of payable.notes">
            <span class="log-row">
              {{ log.date | date: 'M/d/yy' }}
              <ng-container *ngIf="hasLogTime(log.date)">&nbsp;|&nbsp;{{ log.date | date: 'h:mm a' }}</ng-container>
              <ng-container *ngIf="log.initials">&nbsp;|&nbsp;{{ log.initials }}</ng-container>
              <ng-container *ngIf="log.notes">&nbsp;|&nbsp;{{ log.notes }}</ng-container>
            </span>
          </div>
        </ng-container>
        <ng-container *ngIf="payable?.log?.length">
          <h3 class="order-log-title">Log</h3>
          <div class="order-log-row" *ngFor="let log of payable.log">
            <span class="log-row">
              {{ log.date | date: 'M/d/yy' }}
              <ng-container *ngIf="hasLogTime(log.date)">&nbsp;|&nbsp;{{ log.date | date: 'h:mm a' }}</ng-container>
              <ng-container *ngIf="log.initials">&nbsp;|&nbsp;{{ log.initials }}</ng-container>
              <ng-container *ngIf="log.item">
                &nbsp;|&nbsp;
                <ng-container *ngIf="logItemParts(log.item) as parts">
                  <ng-container *ngIf="parts.value; else plainLogItem">
                    {{ parts.label }} {{ logChangeArrow }} <strong class="log-item-value">{{ parts.value }}</strong>
                  </ng-container>
                  <ng-template #plainLogItem>{{ parts.label }}</ng-template>
                </ng-container>
              </ng-container>
            </span>
          </div>
        </ng-container>
      </mat-menu>
    </ng-container>`,
})
export class PayablesListMenuComponent {
  @Input() payable: Payable;
  @Input() type: 'options' | 'log' = 'options';
  @Output() onDelete = new EventEmitter<string>();
  @Output() onPrint = new EventEmitter<string>();
  @Output() onMarkForCredit = new EventEmitter<string>();
  @Output() onView = new EventEmitter<string>();

  logChangeArrow = FormatData.LOG_CHANGE_ARROW;

  logItemParts(item?: string) {
    return FormatData.parseLogItem(item);
  }

  hasLogTime(date?: string): boolean {
    if (!date) {
      return false;
    }
    const raw = String(date).trim();
    if (/^\d+$/.test(raw)) {
      return true;
    }
    const parsed = new Date(raw);
    if (isNaN(parsed.getTime())) {
      return false;
    }
    return (
      parsed.getHours() !== 0 ||
      parsed.getMinutes() !== 0 ||
      parsed.getSeconds() !== 0
    );
  }
}
